import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Tabs,
  Select,
  Table,
  notification,
  Input,
  Button,
  Checkbox,
  Radio,
  Tooltip,
  DatePicker,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { MoreOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import Api from "../../../../services/ServiceApi";
import AssignJobMap from "../../../../ui/map/assign_job";

const { TabPane } = Tabs;
const { Option } = Select;


const changeWorkflowDetailsend = {
  C: { main: 33, sub: -1, from_main_process_id: 33, next_main_action_id: 23 },
  O: { main: 1, sub: -1, from_main_process_id: 1, next_main_action_id: 16 },
};

const initEmployment = {
  employment: null,
  employmentType: null,
  employmentReason: "",
};

export default function AssignJobComponent({
  CompanyId,
  OperatorId,
  ProjectId,
  ModalShow,
  setModalShow,
  workflowJob,
  jobDetail,
  typeModal,
  title,
  AdvanceSearch,
  showOldassign,
  showStartasAckJob,
  Teamgroupdutycode,
  ShowMap,
  // EnableAssignTeam,
  wrapClassName,
}) {
  const [empList, setempList] = useState([]);
  // const [teamList, setteamList] = useState([]);
  const [loading, setloading] = useState(false);
  const [statusSubmit, setstatusSubmit] = useState(false);
  const unmounted = useRef(false);
  const [newWorkflow, setnewWorkflow] = useState([]);
  const [startAsAckJob, setstartAsAckJob] = useState({
    checked: false,
    ackDate: null,
  });
  const [tabActiveKey, setTabActiveKey] = useState("1");
  /* masterdata */
  const [masterTeamsub, setmasterTeamsub] = useState([]);
  const [masterTeamgroup, setmasterTeamgroup] = useState([]);
  const [masterEmpskill, setmasterEmpskill] = useState([]);
  /* tablecolumn */

  const [employment, setEmployment] = useState({
    ...initEmployment,
    employment: jobDetail.employment_flag,
    employmentType: jobDetail.employment_type_flag,
    employmentReason: jobDetail.employment_remark,
  });

  const tableColumnOldAssing = [
    {
      title: "Select",
      dataIndex: "",
      key: "",
      width: 80,
      fixed: "left",
      render: (item) => (
        <Checkbox
          onChange={CheckEmptoAssign}
          item={item}
          remove={true}
          checked={item.checkBox}
        ></Checkbox>
      ),
    },
    // {
    //   title: "Assignment ID",
    //   dataIndex: "job_assign_id",
    //   key: "job_assign_id",
    //   width: 100,
    //   render: (item) => (
    //     <span className="font-thai-r fs-18 mx-center">{item}</span>
    //   ),
    // },
    {
      title: "Emp Code",
      dataIndex: "emp_code",
      key: "emp_code",
      width: 100,
    },
    {
      title: "Name",
      dataIndex: "emp_name",
      key: "emp_name",
      width: 100,
    },
    // {
    //   title: "Skill",
    //   dataIndex: "ma_skill_name",
    //   key: "ma_skill_name",
    //   width: 100,
    // },
    {
      title: "Team Group Name",
      dataIndex: "team_group_name",
      key: "team_group_name",
      width: 100,
    },
    {
      title: "Team Sub Name",
      dataIndex: "team_name",
      key: "team_name",
      width: 100,
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      width: 100,
      render: (item) => (
        <span>
          {item === 1 ? (
            <span className="c-green">
              <span className="dot-active mr-2"></span>Active
            </span>
          ) : (
            <span className="c-red">
              <span className="dot-Inactive mr-2"></span>InActive
            </span>
          )}
        </span>
      ),
    },
    {
      title: "Acknowledge",
      dataIndex: "isAcknowledge",
      key: "isAcknowledge",
      width: 100,
      render: (item) => (
        <span>
          {item ? (
            <span className="c-green">
              <span className="dot-active mr-2"></span>Acknowledge
            </span>
          ) : (
            <span className="c-red">
              <span className="dot-Inactive mr-2"></span>IsAcknowledge
            </span>
          )}
        </span>
      ),
    },
    {
      title: "On Hand Job",
      dataIndex: "current_onhand_job",
      key: "current_onhand_job",
      width: 100,
    },
  ];
  const tableColumnNewAssing = [
    {
      title: "Select",
      dataIndex: "",
      key: "",
      width: 50,
      // fixed: "left",
      render: (item) => (
        <Checkbox
          onChange={CheckEmptoAssign}
          item={item}
          remove={false}
          checked={item.checked}
        ></Checkbox>
      ),
    },
    {
      title: "Emp Code",
      dataIndex: "emp_code",
      key: "emp_code",
      width: 100,
    },
    {
      title: "Name",
      dataIndex: "emp_name",
      key: "emp_name",
      width: 100,
    },
    {
      title: "Skill",
      dataIndex: "ma_skill_name",
      key: "ma_skill_name",
      width: 100,
    },
    {
      title: "Team Group Name",
      dataIndex: "team_group_name",
      key: "team_group_name",
      width: 100,
    },
    {
      title: "Team Sub Name",
      dataIndex: "team_name",
      key: "team_name",
      width: 100,
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      width: 100,
      render: (item) => (
        <span>
          {item === 1 ? (
            <span className="c-green">
              <span className="dot-active mr-2"></span>Active
            </span>
          ) : (
            <span className="c-red">
              <span className="dot-Inactive mr-2"></span>InActive
            </span>
          )}
        </span>
      ),
    },
    {
      title: "On Hand Job",
      dataIndex: "current_onhand_job",
      key: "current_onhand_job",
      align: "center",
    },
    {
      title: "Recommendation",
      dataIndex: "percentage",
      key: "percentage",
      align: "center",
      render: (text, record) => {
        return (
          <div className="row">
            <div className="col-6">{`${record.percentage}%`}</div>
            <div className="col-6">
              <Tooltip
                placement="left"
                color={"#fff"}
                title={
                  <div style={{ width: 160 }}>
                    <div className="row">
                      <div
                        className="col-6"
                        style={{ color: "#6F6F6F", fontSize: 12 }}
                      >
                        Skill
                      </div>
                      <div
                        className="col-6"
                        style={{
                          color: "#80D528",
                          fontSize: 12,
                          textAlign: "center",
                        }}
                      >
                        {`${record.ai_recommend.skill}%`}
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-6"
                        style={{ color: "#6F6F6F", fontSize: 12 }}
                      >
                        Area
                      </div>
                      <div
                        className="col-6"
                        style={{
                          color: "#80D528",
                          fontSize: 12,
                          textAlign: "center",
                        }}
                      >
                        {`${record.ai_recommend.area}%`}
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-6"
                        style={{ color: "#6F6F6F", fontSize: 12 }}
                      >
                        On hand
                      </div>
                      <div
                        className="col-6"
                        style={{
                          color: "#80D528",
                          fontSize: 12,
                          textAlign: "center",
                        }}
                      >
                        {`${record.ai_recommend.job_on_hand}%`}
                      </div>
                    </div>
                  </div>
                }
              >
                <MoreOutlined />
              </Tooltip>
            </div>
          </div>
        );
        // return `${item}%`;
      },
    },
  ];
  const [finishCall, setfinishCall] = useState(false);
  const [selectEmpSkill, setselectEmpSkill] = useState("");
  const [selectTeamGroup, setselectTeamGroup] = useState("");
  const [selsectTeamSub, setselsectTeamSub] = useState("");
  const [searchNameEmp, setsearchNameEmp] = useState("");
  useEffect(() => {
    function fetchMasterData() {
      if (AdvanceSearch && ModalShow) {
        Api.post("master_data/GetTeamGroup", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          team_group_duty_code: Teamgroupdutycode,
        })
          .then((res) => {
            if (res.data.result.value === "P") {
              setmasterTeamgroup(res.data.list);
            }
          })
          .catch((err) => console.log(err));
      }
      Api.post("get_bold_ma_skill", {
        pk_id: null,
        is_active: "1",
        effective: null,
        sql_where: null,
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
      })
        .then((res) => {
          if (res.data.result.value === "P") {
            setmasterEmpskill(res.data.data.result_ma_skill_list);
          }
        })
        .catch((err) => console.log(err));
    }
    if (ModalShow) {
      clearData();
      CallWF(false);
      setstartAsAckJob({ ...startAsAckJob, checked: false });
      GetSearchEmoList();
      fetchMasterData();
    }
    setfinishCall(true);
    return () => {
      unmounted.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AdvanceSearch, ModalShow]);

  function handleSelectChange(value, type) {
    if (type !== undefined && value !== undefined) {
      const selectTypename = type.name;
      switch (selectTypename) {
        default:
          return null;
        case "Empskill":
          setselectEmpSkill(value);
          break;
        case "Teamgroup":
          GetTeamSublist(value);
          setselectTeamGroup(value);
          break;
        case "Teamsub":
          setselsectTeamSub(value);
          break;
      }
    }
  }
  function onChangeinput(e) {
    let name = e.target.name;
    let value = e.target.value;
    if (name !== null) {
      switch (name) {
        default:
          return null;
        case "Empname":
          setsearchNameEmp(value);
          break;
      }
    }
  }
  function closeModal() {
    /* clearstate */
    clearData();
    /* closeModal */
    setModalShow(false);
  }
  function clearData() {
    /* clearstate */
    setselectEmpSkill("");
    setselectTeamGroup("");
    setselsectTeamSub("");
    setsearchNameEmp("");
    setempList([]);
    setmasterTeamsub([]);
    setstatusSubmit(false);
  }

  function GetTeamSublist(team_group_id) {
    Api.post("master_data/GetTeamSub", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      team_group_id: team_group_id,
    })
      .then((res) => {
        if (res.data.result.value === "P") {
          setmasterTeamsub(res.data.list);
          setselsectTeamSub(null);
        }
      })
      .catch((e) => console.log(e));
  }
  let setDatatosubmit = [];
  const [dataToSubmit, setDataToSubmit] = useState([]);
  function GetSearchEmoList() {
    setDatatosubmit = [];
    setDataToSubmit([]);
    setempList([]);
    setloading(true);
    Api.post("job_detail/search_employee_for_assign", {
      team_group_duty_code: Teamgroupdutycode,
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_id: jobDetail.job_id,
      employee_skill: selectEmpSkill !== "" ? selectEmpSkill : null,
      employee_name: searchNameEmp !== "" ? searchNameEmp : null,
      team_group: selectTeamGroup !== "" ? selectTeamGroup : null,
      team_sub: selsectTeamSub !== "" ? selsectTeamSub : null,
      is_active: 1,
    }).then((res) => {
      if (res.data?.result.code === "P") {
        let dataList = [];
        if (res.data) {
          const tempList = res.data?.data;
          tempList.map((e) => {
            if (dataList.findIndex((item) => item.emp_id === e.emp_id) < 0) {
              dataList.push({ ...e, checked: false });
            }
          });
          // res.data?.data.map(e=>{
          // if(res.data?.data.findIndex(item => item.emp_id === e.emp_id) < 0){
          //   dataList.push({ ...e, checked: false });
          // }
          // });
          const result = dataList.filter(word => word.isAssigned === 1);
          result.forEach(element =>  element["checkBox"] =  element.isAcknowledge );

          setempList(dataList);

          // setempList(res.data?.data.map((e) => ({ ...e, checked: false })));
        }
        // setempList(res.data?.data);
        setloading(false);
      } else if (res.data?.result.code === "F") {
        setloading(false);
      }
    });
  }

  function CallWF(checked) {
    if (checked) {
      Api.post("getButtonDetailWeb", {
        ActionID: 1,
        CompanyID: CompanyId,
        JobTypeID: jobDetail.job_type_id,
        MainProcessID: changeWorkflowDetailsend[Teamgroupdutycode].main,
        ProjectID: ProjectId,
        SubProcessID: changeWorkflowDetailsend[Teamgroupdutycode].sub,
        UserName: Cookies.get("username"),
        Version: 1,
        WF_ID: 0,
        operator_id: OperatorId,
      })
        .then((res) => {
          setnewWorkflow(res.data.return_nextWorkFlow);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  function onTogglestartackJob(e) {
    let Checked = e.target.checked;
    CallWF(Checked);
    setstartAsAckJob({ ...startAsAckJob, checked: Checked });
  }

  function CheckEmptoAssign(e, item) {
    const result1 = empList.filter(word => word.emp_id === e.target.item.emp_id);
    const result2 = empList.filter(word => word.emp_id !== e.target.item.emp_id);
    result1[0]["checkBox"] = e.target.checked;
    result2.forEach(element => element["checkBox"] = false );

    
    let userChecked = e.target.checked;
    let EmpitemChecked = e.target.item;
    let Removeorpush = e.target.remove;
    switch (typeModal) {
      default:
        return null;
      case "assign":
        if (userChecked) {
          workflowJob.map((data, index) => {
            if (
              (data.next_main_action_id === 16 && Teamgroupdutycode === "O") ||
              (data.next_main_action_id === 23 && Teamgroupdutycode === "C")
            ) {
              let tempPusharrEmp = {
                ...workflowJob[index],
                job_no: jobDetail.job_no,
                emp_code: EmpitemChecked.emp_id,
                create_by: Cookies.get("username"),
                company_id: CompanyId,
                operator_id: OperatorId,
                project_id: ProjectId,
                job_progress_id: jobDetail.job_progress_id,
                flag_reassign: "assign",
                emp_or_team: "E",
                job_id: jobDetail.job_id,
                team_id: EmpitemChecked.team_id,
                team_group_id: EmpitemChecked.team_group_id,
                team_group_duty_code: EmpitemChecked.team_group_duty_code,
                subflag: EmpitemChecked.subflag,
                reason: "",
              };
              setDatatosubmit.push(tempPusharrEmp);
              if (
                dataToSubmit.findIndex(
                  (e) => e.emp_code === EmpitemChecked.emp_id
                ) < 0
              ) {
                setDataToSubmit([...dataToSubmit, tempPusharrEmp]);
              }
            }
          });
        } else {
          if (setDatatosubmit.length > 0) {
            setDatatosubmit.map((data, index) => {
              if (data.emp_code === EmpitemChecked.emp_id) {
                setDatatosubmit.splice(index, 1);
              }
            });
          }

          setDataToSubmit(
            dataToSubmit.filter((e) => e.emp_code !== EmpitemChecked.emp_id)
          );
        }

        setempList(
          empList.map((e) => {
            if (
              e.emp_id === EmpitemChecked.emp_id &&
              e.ma_skill_name === EmpitemChecked.ma_skill_name
            ) {
              return { ...e, checked: userChecked };
            } else {
              return e;
            }
          })
        );
        break;
      case "manage":
        if (userChecked) {
          workflowJob.map((data, index) => {
            if (
              (data.next_main_action_id === 40 && Teamgroupdutycode === "C") ||
              (data.next_main_action_id === 41 && Teamgroupdutycode === "O")
            ) {
              if (!Removeorpush) {
                let tempPusharrEmp = {
                  ...workflowJob[index],
                  job_no: jobDetail.job_no,
                  emp_code: EmpitemChecked.emp_id,
                  create_by: Cookies.get("username"),
                  company_id: CompanyId,
                  operator_id: OperatorId,
                  project_id: ProjectId,
                  job_progress_id: jobDetail.job_progress_id,
                  flag_reassign: "assign",
                  emp_or_team: "E",
                  job_id: jobDetail.job_id,
                  team_id: EmpitemChecked.team_id,
                  team_group_id: EmpitemChecked.team_group_id,
                };
                setDatatosubmit.push(tempPusharrEmp);
                if (
                  dataToSubmit.findIndex(
                    (e) => e.emp_code === EmpitemChecked.emp_id
                  ) < 0
                ) {
                  setDataToSubmit([...dataToSubmit, tempPusharrEmp]);
                }
              } else {
                //
                let tempPusharrEmp = {
                  ...workflowJob[index],
                  job_no: jobDetail.job_no,
                  emp_code: EmpitemChecked.emp_id,
                  create_by: Cookies.get("username"),
                  company_id: CompanyId,
                  operator_id: OperatorId,
                  project_id: ProjectId,
                  job_progress_id: jobDetail.job_progress_id,
                  flag_reassign: "assign",
                  emp_or_team: "E",
                  job_id: jobDetail.job_id,
                  team_id: EmpitemChecked.team_id,
                  team_group_id: EmpitemChecked.team_group_id,
                  withdraw_flag: 0,
                  job_assign_id: EmpitemChecked.job_assign_id,
                };

                setDatatosubmit = [tempPusharrEmp];
                setDataToSubmit([tempPusharrEmp]);

              }
            }
          });

        } else {
          if (setDatatosubmit.length > 0) {
            setDatatosubmit.map((data, index) => {
              if (data.emp_code === EmpitemChecked.emp_id) {
                setDatatosubmit.splice(index, 1);
              }
            });
          }
          setDataToSubmit(
            dataToSubmit.filter((e) => e.emp_code !== EmpitemChecked.emp_id)
          );
        }
        setstartAsAckJob({
          checked: e.target.checked,
          ackDate: null,
        });
        setempList(
          empList.map((e) => {
            if (
              e.emp_id === EmpitemChecked.emp_id &&
              e.ma_skill_name === EmpitemChecked.ma_skill_name
            ) {
              return { ...e, checked: userChecked };
            } else {
              if (Removeorpush) {
                return { ...e, checked: false };
              } else {
                return e;
              }
            }
          })
        );
        break;
    }
  }

  async function SendAssign() {
    setstatusSubmit(true);
    // if (
    //   setDatatosubmit !== undefined &&
    //   setDatatosubmit.length === 0 &&
    //   !startAsAckJob
    // ) {
    if (
      dataToSubmit !== undefined &&
      dataToSubmit.length === 0 &&
      !startAsAckJob.checked
    ) {
      notification.warning({
        message: "แจ้งเตือน",
        description: "กรุณาเลือกคนที่ต้องการมอบหมายงาน",
        duration: 5,
        className: "font-thai-b fs-18",
      });
      setstatusSubmit(false);
    }
    switch (typeModal) {
      default:
        return null;
      case "assign":
        workflowJob.map((data, index) => {
          if (
            (data.next_main_action_id === 16 && Teamgroupdutycode === "O") ||
            (data.next_main_action_id === 23 && Teamgroupdutycode === "C")
          ) {
            Api.post("update_job_ma_to_employee_trs", {
              employment: {
                ...employment,
                jobId: jobDetail.job_id,
                companyId: CompanyId,
                operatorId: OperatorId,
                projectId: ProjectId,
                userId: Cookies.get("userId"),
                userName: Cookies.get("username"),
              },
              employees: dataToSubmit.map((e) => ({
                ...e,
                acknowledge_status: startAsAckJob.checked ? "Y" : "N",
                acknowledge_date:
                  startAsAckJob.ackDate === "" ? null : startAsAckJob.ackDate,
              })), //setDatatosubmit,
            }).then((res) => {
              if (res.data.result.code === "P") {
                setModalShow(false);
                notification.success({
                  message: "Assign งานเรียบร้อยแล้ว",
                  description: "ท่านสามารถตรวจสอบรายละเอียดงานได้ที่เมนูถัดไป",
                  duration: 5,
                  className: "font-thai-b fs-18",
                });
                setstatusSubmit(false);
                setDatatosubmit = [];
                setDataToSubmit([]);
                window.location.reload(false);
              } else if (res.data.result.code === "F") {
                setModalShow(false);
                notification.error({
                  message: "Error",
                  description: res.data.result?.showText,
                  duration: 5,
                  className: "font-thai-b fs-18",
                });
                setstatusSubmit(false);
              }
            });
          }
        });
        if (workflowJob?.length === 0) {
          notification.error({
            message: "ผิดพลาด",
            description: "คุณไม่มีสิทธ์ในการใช้งาน",
            duration: 5,
            className: "font-thai-b fs-18",
          });
          setstatusSubmit(false);
        }
        break;
      case "manage":
        workflowJob.map((data, index) => {
          if (
            (data.next_main_action_id === 40 && Teamgroupdutycode === "C") ||
            (data.next_main_action_id === 41 && Teamgroupdutycode === "O")
          ) {
            // if (setDatatosubmit.length > 0) {
            if (dataToSubmit.length > 0) {
              Api.post("update_job_ma_to_employee_trs", {
                employment: {
                  ...employment,
                  jobId: jobDetail.job_id,
                  companyId: CompanyId,
                  operatorId: OperatorId,
                  projectId: ProjectId,
                  userId: Cookies.get("userId"),
                  userName: Cookies.get("username"),
                },
                employees: dataToSubmit.map((e) => ({
                  ...e,
                  acknowledge_status: startAsAckJob.checked ? "Y" : "N",
                  acknowledge_date:
                    startAsAckJob.ackDate === "" ? null : startAsAckJob.ackDate,
                })), //setDatatosubmit,
              }).then((res) => {
                if (res.data.result.code === "P") {
                  setModalShow(false);
                  notification.success({
                    message: "Assign งานเรียบร้อยแล้ว",
                    description:
                      "ท่านสามารถตรวจสอบรายละเอียดงานได้ที่เมนูถัดไป",
                    duration: 5,
                    className: "font-thai-b fs-18",
                  });

                  setstatusSubmit(false);
                  setDatatosubmit = [];
                  setDataToSubmit([]);
                  if (startAsAckJob.checked) {
                    sendAckjobstatus();
                    //setstatusSubmit(false);
                  } else {
                    window.location.reload(false);
                  }
                } else if (res.data.result.code === "F") {
                  setModalShow(false);
                  notification.error({
                    message: "Error",
                    description: res.data.result?.showText,
                    duration: 5,
                    className: "font-thai-b fs-18",
                  });
                  setstatusSubmit(false);
                }
              });
            } else {
              if (startAsAckJob.checked) {
                sendAckjobstatus();
                setstatusSubmit(false);
                setModalShow(false);
              }
            }
          }
        });
        if (workflowJob?.length === 0) {
          notification.error({
            message: "ผิดพลาด",
            description: "คุณไม่มีสิทธ์ในการใช้งาน",
            duration: 5,
            className: "font-thai-b fs-18",
          });
          setstatusSubmit(false);
        }
        break;
    }
  }
  function sendAckjobstatus() {
    newWorkflow.map((data, index) => {
      if (
        data.from_main_process_id ===
        changeWorkflowDetailsend[Teamgroupdutycode].from_main_process_id &&
        data.next_main_action_id ===
        changeWorkflowDetailsend[Teamgroupdutycode].next_main_action_id
      ) {
        const param = {
          employment: {
            ...employment,
            jobId: jobDetail.job_id,
            companyId: CompanyId,
            operatorId: OperatorId,
            projectId: ProjectId,
            userId: Cookies.get("userId"),
            userName: Cookies.get("username"),
          },
          employees: [
            {
              ...newWorkflow[index],
              company_id: CompanyId,
              operator_id: OperatorId,
              project_id: ProjectId,
              job_progress_id: jobDetail.job_progress_id,
              job_id: jobDetail.job_id,
              emp_or_team: "E",
              emp_code: Number(Cookies.get("userId")),
              create_by: Cookies.get("username"),
              acknowledge_status: startAsAckJob.checked ? "Y" : "N",
              acknowledge_date:
                startAsAckJob.ackDate === "" ? null : startAsAckJob.ackDate,
            },
          ],
        };

        Api.post("update_job_ma_to_employee_trs", param).then((res) => {
          if (res.data.result.code === "P") {
            notification.info({
              message: "แจ้งเตือน",
              description: `งานหมายเลข ${jobDetail.job_no} ถูกปรับให้มาอยู่ที่สถานะ Acknowledge Job แล้ว`,
              duration: 5,
              className: "font-thai-b fs-18",
            });
            window.location.reload(false);
          } else if (res.data.result.code === "F") {
            notification.error({
              message: "Error",
              description: res.data.result?.showText,
              duration: 5,
              className: "font-thai-b fs-18",
            });
          }
        });
      }
    });
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Age",
      dataIndex: "age",
    },
    {
      title: "Address",
      dataIndex: "address",
    },
  ];

  const data = [];
  for (let i = 0; i < 46; i++) {
    data.push({
      key: i,
      name: `Edward King ${i}`,
      age: 32,
      address: `London, Park Lane no. ${i}`,
    });
  }

  const [stateTable, setStateTable] = useState({ selectedRowKeys: [] });

  const onSelectChange = (selectedRowKeys) => {
    setStateTable({ selectedRowKeys });
  };
  const { selectedRowKeys } = stateTable;
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const clearDataSelected = () => {
    setDataToSubmit([]);
    empList.map((e) => (e.checked = false));
    setDatatosubmit = [];
  };
  return (
    <>
      <Modal
        title={null}
        visible={ModalShow}
        centered
        footer={null}
        closable={false}
        wrapClassName={wrapClassName}
        className="custom-modal-map-large"
      >
        {finishCall ? (
          <div className="row">
            {ShowMap ? (
              <div className="col col-12 col-md-4">
                <AssignJobMap></AssignJobMap>
              </div>
            ) : null}
            <div className={ShowMap ? `col col-12 col-md-8` : `col col-12`}>
              <div className="assign-modal">
                <div className="assign-modal-header">
                  <h4>
                    {title
                      ? `${title} : ${jobDetail.job_no}`
                      : jobDetail.job_no}
                  </h4>
                </div>
                <div className="assign-modal-body">
                  <Tabs
                    defaultActiveKey="1"
                    onChange={(key) => {
                      setTabActiveKey(key);
                      clearDataSelected();
                      if (key === "1") {
                        setstartAsAckJob({
                          checked: false,
                          ackDate: null,
                        });
                      }
                    }}
                  >
                    <TabPane tab="ค้นหารายชื่อ" key="1">
                      <div
                        className="wrapper-search-list"
                        style={{ padding: "0px 10px" }}
                      >
                        {AdvanceSearch ? (
                          <>
                            <div className="row">
                              <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Team Group
                                  </span>
                                </div>
                                <div className="row">
                                  <Select
                                    name="Teamgroup"
                                    defaultValue=""
                                    style={{ border: "0px", width: "100%" }}
                                    placeholder="Select a Team Group"
                                    className="inputfile"
                                    onChange={handleSelectChange}
                                    value={selectTeamGroup}
                                  >
                                    <Option
                                      value=""
                                      name="Teamgroup"
                                    >{`All Team Group`}</Option>
                                    {masterTeamgroup &&
                                      masterTeamgroup.length > 0
                                      ? masterTeamgroup.map((data, index) => (
                                        <Option
                                          key={`option_team_group_api_${index}`}
                                          value={data.team_group_id}
                                          name="Teamgroup"
                                        >
                                          {data.team_group_name}
                                        </Option>
                                      ))
                                      : null}
                                  </Select>
                                </div>
                              </div>
                              <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Team Sub
                                  </span>
                                </div>
                                <div className="row">
                                  <Select
                                    name="Teamsub"
                                    defaultValue=""
                                    style={{ border: "0px", width: "100%" }}
                                    placeholder="Select a Team Sub"
                                    className="inputfile"
                                    onChange={handleSelectChange}
                                    value={selsectTeamSub}
                                  >
                                    <Option
                                      value=""
                                      name="Teamsub"
                                    >{`All Sub Team`}</Option>
                                    {masterTeamsub && masterTeamsub.length > 0
                                      ? masterTeamsub.map((data, index) => (
                                        <Option
                                          key={`option_team_sum_api_${index}`}
                                          value={data.team_id}
                                          name="Teamsub"
                                        >
                                          {data.team_name}
                                        </Option>
                                      ))
                                      : null}
                                  </Select>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Employee Skill
                                  </span>
                                </div>
                                <div className="row">
                                  <Select
                                    defaultValue=""
                                    style={{ border: "0px", width: "100%" }}
                                    placeholder="Select a Employee Skill"
                                    className="inputfile"
                                    onChange={handleSelectChange}
                                    value={selectEmpSkill}
                                  >
                                    <Option
                                      value=""
                                      name="Empskill"
                                    >{`All Skill`}</Option>
                                    {masterEmpskill && masterEmpskill.length > 0
                                      ? masterEmpskill.map((data, index) => (
                                        <Option
                                          key={`option_emp_skill_api_${index}`}
                                          value={data.ma_skill_id}
                                          name="Empskill"
                                        >
                                          {data.ma_skill_name}
                                        </Option>
                                      ))
                                      : null}
                                  </Select>
                                </div>
                              </div>
                              <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Employee Name
                                  </span>
                                </div>
                                <div className="row">
                                  <div className="col">
                                    <Input
                                      placeholder="Pleace input Employee name"
                                      className="inputfile"
                                      style={{
                                        border: "1px solid #d9d9d9",
                                        height: 38,
                                      }}
                                      value={searchNameEmp}
                                      onChange={onChangeinput}
                                      name="Empname"
                                    />
                                  </div>

                                  <button
                                    // type="primary"
                                    // htmlType="button"
                                    className="btn-submit"
                                    style={{
                                      margin: "3px 0px",
                                      padding: "0px 15px",
                                    }}
                                    onClick={GetSearchEmoList}
                                  >
                                    <SearchOutlined style={{ fontSize: 18 }} />
                                  </button>
                                </div>
                              </div>
                            </div>
                            {/* <div className="row mb-2">
                              <div className="col-6">
                                <div className="row">
                                  <div className="col-4">
                                    <div className="row">
                                      <span className="font-thai-r fs-18">
                                        Employee Skill
                                      </span>
                                    </div>
                                    <div className="row">
                                      <Select
                                        defaultValue=""
                                        style={{ border: "0px", width: "100%" }}
                                        placeholder="Select a Employee Skill"
                                        className="inputfile"
                                        onChange={handleSelectChange}
                                        value={selectEmpSkill}
                                      >
                                        <Option
                                          value=""
                                          name="Empskill"
                                        >{`All Skill`}</Option>
                                        {masterEmpskill &&
                                        masterEmpskill.length > 0
                                          ? masterEmpskill.map(
                                              (data, index) => (
                                                <Option
                                                  key={`option_emp_skill_api_${index}`}
                                                  value={data.ma_skill_id}
                                                  name="Empskill"
                                                >
                                                  {data.ma_skill_name}
                                                </Option>
                                              )
                                            )
                                          : null}
                                      </Select>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="row">
                                      <span className="font-thai-r fs-18">
                                        Team Group
                                      </span>
                                    </div>
                                    <div className="row">
                                      <Select
                                        name="Teamgroup"
                                        defaultValue=""
                                        style={{ border: "0px", width: "100%" }}
                                        placeholder="Select a Team Group"
                                        className="inputfile"
                                        onChange={handleSelectChange}
                                        value={selectTeamGroup}
                                      >
                                        <Option
                                          value=""
                                          name="Teamgroup"
                                        >{`All Team Group`}</Option>
                                        {masterTeamgroup &&
                                        masterTeamgroup.length > 0
                                          ? masterTeamgroup.map(
                                              (data, index) => (
                                                <Option
                                                  key={`option_team_group_api_${index}`}
                                                  value={data.team_group_id}
                                                  name="Teamgroup"
                                                >
                                                  {data.team_group_name}
                                                </Option>
                                              )
                                            )
                                          : null}
                                      </Select>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="row">
                                      <span className="font-thai-r fs-18">
                                        Team Sub
                                      </span>
                                    </div>
                                    <div className="row">
                                      <Select
                                        name="Teamsub"
                                        defaultValue=""
                                        style={{ border: "0px", width: "100%" }}
                                        placeholder="Select a Team Sub"
                                        className="inputfile"
                                        onChange={handleSelectChange}
                                        value={selsectTeamSub}
                                      >
                                        <Option
                                          value=""
                                          name="Teamsub"
                                        >{`All Sub Team`}</Option>
                                        {masterTeamsub &&
                                        masterTeamsub.length > 0
                                          ? masterTeamsub.map((data, index) => (
                                              <Option
                                                key={`option_team_sum_api_${index}`}
                                                value={data.team_id}
                                                name="Teamsub"
                                              >
                                                {data.team_name}
                                              </Option>
                                            ))
                                          : null}
                                      </Select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-6">
                                <div
                                  className="row"
                                  style={{ alignItems: "flex-end" }}
                                >
                                  <div className="col-8" style={{ padding: 0 }}>
                                    <div className="row">
                                      <span className="font-thai-r fs-18">{`Employee Name`}</span>
                                    </div>
                                    <div className="row">
                                      <Input
                                        placeholder="Pleace input Employee name"
                                        className="inputfile"
                                        style={{
                                          border: "1px solid #d9d9d9",
                                          height: 38,
                                        }}
                                        value={searchNameEmp}
                                        onChange={onChangeinput}
                                        name="Empname"
                                      ></Input>
                                    </div>
                                  </div>
                                  <div className="col-2" style={{ padding: 0 }}>
                                    <Button
                                      type="primary"
                                      htmlType="button"
                                      className="mt-1"
                                      onClick={GetSearchEmoList}
                                    >
                                      Search
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                            <div
                              className="mt-3 mb-3"
                              style={{
                                width: "100%",
                                height: 2,
                                backgroundColor: "#E8ECEF",
                              }}
                            />
                            <div className="row">
                              <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Employment
                                  </span>
                                </div>
                                <div className="row">
                                  <Radio.Group
                                    name="employment"
                                    value={employment.employment}
                                    onChange={(e) => {
                                      const { value } = e.target;
                                      setEmployment({
                                        ...employment,
                                        employment: value,
                                      });
                                    }}
                                  >
                                    <Radio value={1}>
                                      <span className="fs-18 c-blue">จ้าง</span>
                                    </Radio>
                                    <Radio value={2}>
                                      <span className="fs-18 c-blue">
                                        ไม่จ้าง
                                      </span>
                                    </Radio>
                                  </Radio.Group>
                                </div>
                              </div>
                              <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Employment Type
                                  </span>
                                </div>
                                <div className="row">
                                  <Radio.Group
                                    name="employmentType"
                                    value={employment.employmentType}
                                    onChange={(e) => {
                                      const { value } = e.target;
                                      setEmployment({
                                        ...employment,
                                        employmentType: value,
                                      });
                                    }}
                                  >
                                    <Radio value={1}>
                                      <span className="fs-18 c-blue">
                                        จ้างเหมา
                                      </span>
                                    </Radio>
                                    <Radio value={2}>
                                      <span className="fs-18 c-blue">
                                        จ้างรายครั้ง
                                      </span>
                                    </Radio>
                                  </Radio.Group>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-12">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Reason
                                  </span>
                                </div>
                                <div className="row">
                                  <Input.TextArea
                                    name="employmentReason"
                                    className="inputfile c-blue"
                                    value={employment.employmentReason}
                                    rows={2}
                                    onChange={(e) => {
                                      const { value } = e.target;
                                      setEmployment({
                                        ...employment,
                                        employmentReason: value,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            {/* <div
                              className="row mb-2"
                              style={{ alignItems: "flex-end" }}
                            >
                              <div className="col-4">
                                <div className="row">
                                  <div className="col-12">
                                    <div className="row">
                                      <span className="font-thai-r fs-18">
                                        Employment
                                      </span>
                                    </div>
                                    <div className="row">
                                      <Radio.Group
                                        name="employment"
                                        value={employment.employment}
                                        onChange={(e) => {
                                          const { value } = e.target;
                                          setEmployment({
                                            ...employment,
                                            employment: value,
                                          });
                                        }}
                                      >
                                        <Radio value={1}>
                                          <span className="fs-18 c-blue">
                                            จ้าง
                                          </span>
                                        </Radio>
                                        <Radio value={2}>
                                          <span className="fs-18 c-blue">
                                            ไม่จ้าง
                                          </span>
                                        </Radio>
                                      </Radio.Group>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-12">
                                    <div className="row">
                                      <span className="font-thai-r fs-18">
                                        Employment Type
                                      </span>
                                    </div>
                                    <div className="row">
                                      <Radio.Group
                                        name="employmentType"
                                        value={employment.employmentType}
                                        onChange={(e) => {
                                          const { value } = e.target;
                                          setEmployment({
                                            ...employment,
                                            employmentType: value,
                                          });
                                        }}
                                      >
                                        <Radio value={1}>
                                          <span className="fs-18 c-blue">
                                            จ้างเหมา
                                          </span>
                                        </Radio>
                                        <Radio value={2}>
                                          <span className="fs-18 c-blue">
                                            จ้างรายครั้ง
                                          </span>
                                        </Radio>
                                      </Radio.Group>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="row">
                                  <div className="col-12">
                                    <div className="row">
                                      <span className="font-thai-r fs-18">
                                        Reason
                                      </span>
                                    </div>
                                    <div className="row">
                                      <Input.TextArea
                                        name="employmentReason"
                                        className="inputfile c-blue"
                                        value={employment.employmentReason}
                                        rows={2}
                                        onChange={(e) => {
                                          const { value } = e.target;
                                          setEmployment({
                                            ...employment,
                                            employmentReason: value,
                                          });
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                            {/* <div className="row ml-1">
                              <div className="col-3 mr-1">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Employee Skill
                                  </span>
                                </div>
                                <div className="row">
                                  <Select
                                    defaultValue=""
                                    style={{ border: "0px", width: "100%" }}
                                    placeholder="Select a Employee Skill"
                                    className="inputfile"
                                    onChange={handleSelectChange}
                                    value={selectEmpSkill}
                                  >
                                    <Option
                                      value=""
                                      name="Empskill"
                                    >{`All Skill`}</Option>
                                    {masterEmpskill && masterEmpskill.length > 0
                                      ? masterEmpskill.map((data, index) => (
                                          <Option
                                            key={`option_emp_skill_api_${index}`}
                                            value={data.ma_skill_id}
                                            name="Empskill"
                                          >
                                            {data.ma_skill_name}
                                          </Option>
                                        ))
                                      : null}
                                  </Select>
                                </div>
                              </div>
                              <div className="col-2 mr-1">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Team Group
                                  </span>
                                </div>
                                <div className="row">
                                  <Select
                                    name="Teamgroup"
                                    defaultValue=""
                                    style={{ border: "0px", width: "100%" }}
                                    placeholder="Select a Team Group"
                                    className="inputfile"
                                    onChange={handleSelectChange}
                                    value={selectTeamGroup}
                                  >
                                    <Option
                                      value=""
                                      name="Teamgroup"
                                    >{`All Team Group`}</Option>
                                    {masterTeamgroup &&
                                    masterTeamgroup.length > 0
                                      ? masterTeamgroup.map((data, index) => (
                                          <Option
                                            key={`option_team_group_api_${index}`}
                                            value={data.team_group_id}
                                            name="Teamgroup"
                                          >
                                            {data.team_group_name}
                                          </Option>
                                        ))
                                      : null}
                                  </Select>
                                </div>
                              </div>
                              <div className="col-2 mr-1">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Team Sub
                                  </span>
                                </div>
                                <div className="row">
                                  <Select
                                    name="Teamsub"
                                    defaultValue=""
                                    style={{ border: "0px", width: "100%" }}
                                    placeholder="Select a Team Sub"
                                    className="inputfile"
                                    onChange={handleSelectChange}
                                    value={selsectTeamSub}
                                  >
                                    <Option
                                      value=""
                                      name="Teamsub"
                                    >{`All Sub Team`}</Option>
                                    {masterTeamsub && masterTeamsub.length > 0
                                      ? masterTeamsub.map((data, index) => (
                                          <Option
                                            key={`option_team_sum_api_${index}`}
                                            value={data.team_id}
                                            name="Teamsub"
                                          >
                                            {data.team_name}
                                          </Option>
                                        ))
                                      : null}
                                  </Select>
                                </div>
                              </div>
                            </div> */}
                            {/* <div className="row ml-1">
                              <div className="col-5 mr-2">
                                <div className="row">
                                  <span className="font-thai-r fs-18">{`Employee Name`}</span>
                                </div>
                                <div className="row">
                                  <Input
                                    placeholder="Pleace input Employee name"
                                    className="inputfile"
                                    value={searchNameEmp}
                                    onChange={onChangeinput}
                                    name="Empname"
                                  ></Input>
                                </div>
                              </div>
                              <div className="col-2">
                                <div className="row mt-4">
                                  <Button
                                    type="primary"
                                    htmlType="button"
                                    className="mt-1"
                                    onClick={GetSearchEmoList}
                                  >
                                    Search
                                  </Button>
                                </div>
                              </div>
                            </div> */}
                          </>
                        ) : (
                          <>
                            <div className="row ml-1">
                              <div className="col-3 mr-1">
                                <div className="row">
                                  <span className="font-thai-r fs-18">
                                    Employee Skill
                                  </span>
                                </div>
                                <div className="row">
                                  <Select
                                    allowClear
                                    name="Empskill"
                                    defaultValue=""
                                    style={{ border: "0px", width: "100%" }}
                                    placeholder="Select a Employee Skill"
                                    className="inputfile"
                                    onChange={handleSelectChange}
                                  //value={selectEmpSkill}
                                  >
                                    <Option
                                      value=""
                                      name="Empskill"
                                    >{`All Skill`}</Option>
                                    {masterEmpskill && masterEmpskill.length > 0
                                      ? masterEmpskill.map((data, index) => (
                                        <Option
                                          key={`option_emp_skill_api_${index}`}
                                          value={data.ma_skill_id}
                                          name="Empskill"
                                        >
                                          {data.ma_skill_name}
                                        </Option>
                                      ))
                                      : null}
                                  </Select>
                                </div>
                              </div>
                              <div className="col-5 mr-2">
                                <div className="row">
                                  <span className="font-thai-r fs-18">{`Employee Name`}</span>
                                </div>
                                <div className="row">
                                  <Input
                                    placeholder="Pleace input Employee name"
                                    className="inputfile"
                                    value={searchNameEmp}
                                    onChange={onChangeinput}
                                    name="Empname"
                                  ></Input>
                                </div>
                              </div>
                              <div className="col-2">
                                <div className="row mt-4">
                                  <Button
                                    type="primary"
                                    htmlType="button"
                                    className="mt-1"
                                  >
                                    Search
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="wrapper-search-result">
                        <span>ผลการค้นหา</span>
                        <Table
                          size="small"
                          rowKey="employee_id"
                          loading={loading}
                          rowSelection={""}
                          columns={tableColumnNewAssing}
                          dataSource={empList.filter(
                            (data) => data.isAssigned === 0
                          )}
                          scroll={{ x: 1000 }}
                          // sticky={true}
                          style={{
                            whiteSpace: "nowrap",
                            lineHeight: "0.7 !important",
                          }}
                        />
                        {/* <Table
                          rowSelection={rowSelection}
                          columns={columns}
                          dataSource={data}
                        /> */}
                      </div>
                    </TabPane>
                    {showOldassign ? (
                      <>
                        <TabPane tab="รายชื่อคนใน Job" key="2">
                          <div className="wrapper-search-result">
                            <span>รายชื่อคนใน Job</span>
                            <Table
                              size="small"
                              rowKey="employee_id"
                              loading={loading}
                              rowSelection={""}
                              columns={tableColumnOldAssing}
                              dataSource={empList.filter(
                                (data) => data.isAssigned === 1
                              )}
                              style={{
                                whiteSpace: "nowrap",
                                lineHeight: "0.7 !important",
                              }}
                              scroll={{
                                x: 1300,
                              }}
                            />
                          </div>
                        </TabPane>
                      </>
                    ) : null}
                  </Tabs>
                </div>
                <div className="assign-modal-footer">
                  {showStartasAckJob ? (
                    <div className="row d-flex justify-content-center mt-2">
                      <div className="col divhide" >
                        <Checkbox
                          onChange={onTogglestartackJob}
                          checked={
                            tabActiveKey === "1" ? false : startAsAckJob.checked
                          }
                          disabled={tabActiveKey === "1"}
                        >
                          Start at acknowledge job
                        </Checkbox>
                      </div>
                      {/* <div className="col-lg-6">
                        <DatePicker
                          showTime={{ format: "HH:mm" }}
                          disabled={!startAsAckJob.checked}
                          placeholder="Ack. Date"
                          format="YYYY-MM-DD HH:mm"
                          onChange={(value, dateString) => {
                            setstartAsAckJob({
                              ...startAsAckJob,
                              ackDate: dateString,
                            });
                          }}
                          style={{
                            width: "100%",
                            color: "#000f9f !important",
                          }}
                          className="inputfile c-blue"
                        />
                      </div> */}
                    </div>
                  ) : null}
                  <button
                    type="reset"
                    onClick={closeModal}
                    className="btn btn-secondary"
                  >
                    Close
                  </button>
                  {statusSubmit ? (
                    <button className="btn btn-success" disabled>
                      <div className="d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    </button>
                  ) : (
                    <button
                      className="btn btn-success"
                      onClick={() => SendAssign()}
                    >
                      {`${tabActiveKey === "1"
                          ? `Assign (${dataToSubmit.length})`
                          : `Submit (${dataToSubmit.length})`
                        }`}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </Modal>
    </>
  );
}
